import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  value: string;
  label: string;
};

const FieldView = ({ value, label }: Props) => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'row', sm: 'row', md: 'column' }}
      alignItems="center"
      padding={{ xs: '0', sm: '0', md: "0 10px" }}
    >
      <Box>
        <Typography
          variant="overline"
          color="text.secondary"
          fontWeight={700}
          lineHeight="32px"
          textTransform="uppercase"
          id="lbl-fieldview-label"
          padding="0 10px"
        >
          {label}
        </Typography>
      </Box>
      <Typography width="max-content" variant="body2" color="text.secondary" id="lbl-fieldview-value">
        {value}
      </Typography>
    </Box>
  );
};

export default FieldView;
